import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// =============================================================================
// RouteTitle
//
// Updates document.title whenever the SPA route changes. Without this,
// every page-load shows the static <title> from index.html ("RT | Mount
// Sinai Trip Request Form") regardless of where the user is — confusing
// for tab-switchers and screen-reader users who rely on the title to
// know what page they just landed on.
//
// Intentionally driven by location.pathname rather than per-page
// `useDocumentTitle` calls — keeps the catalog of route → title in one
// place, makes adding a new route a one-line change.
// =============================================================================

const TITLES: Record<string, string> = {
  "/login": "Sign in",
  "/forgot-password": "Forgot password",
  "/auth/magic": "Signing in",
  "/auth/invite": "Accept invitation",
  "/auth/reset-password": "Reset password",
  "/": "Trip request",
  "/booked": "Booked trips",
  "/account": "Account",
  "/admin/users": "Users",
  "/admin/bookings": "Bookings",
  "/admin/members": "Members",
  "/admin/departments": "Departments",
  "/admin/locations": "Locations",
  "/admin/audit": "Audit log",
  "/admin/reports": "Reports",
  "/admin/tms-cleanup": "TMS Cleanup",
  "/admin/permissions": "Permissions",
};

const SUFFIX = "Mount Sinai Trip Request";

export function RouteTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const label = TITLES[pathname];
    document.title = label ? `${label} · ${SUFFIX}` : `RT | ${SUFFIX}`;
  }, [pathname]);
  return null;
}
